// Pure helpers turning solved comfort objectives into heating windows and the
// "planned actions" list. A window is [preheat_start, target_time + duration]:
// heat up to the target, then keep it warm for the event's duration.

// When an event's heating ends, as an ISO string (UTC).
export function eventEnd(e) {
    const minutes = e.duration_minutes || 0;
    return new Date(new Date(e.target_time).getTime() + minutes * 60000).toISOString();
}

export function windowsFromEvents(events) {
    return (events || [])
        .filter(e => e.preheat_start && e.target_time)
        .map(e => ({ start: e.preheat_start, end: eventEnd(e), temp: e.target_temperature, label: e.label }));
}

// The next `limit` on/off transitions at or after `now` (ms), soonest first.
export function deriveActions(windows, now = Date.now(), limit = 6) {
    const actions = [];
    (windows || []).forEach(w => {
        actions.push({ time: w.start, action: 'on', temp: w.temp, label: w.label });
        actions.push({ time: w.end, action: 'off', label: w.label });
    });
    return actions
        .filter(a => new Date(a.time).getTime() >= now)
        .sort((a, b) => new Date(a.time) - new Date(b.time))
        .slice(0, limit);
}

export const sortByTargetTime = (events) =>
    [...(events || [])].sort((a, b) => new Date(a.target_time) - new Date(b.target_time));
